<ng-template #cancellationRates>
  <alert-content
    (emitterHide)="hide()"
    [title]="'OTHER_OPTIONS'"
    [imageName]="'cancel-rates-alert.svg'"
  ></alert-content>
</ng-template>
<div class="header">
  <div *ngIf="!isHomestay">Habitación</div>
  <div *ngIf="isHomestay">Detalle</div>
  <div>Opciones</div>
  <div>Tipo de pago y precio de la reserva</div>
</div>
<ng-container *ngIf="!isDisney; else disneyCluster">
  <ng-container *ngIf="(rooms$ | async).length; else noRooms">
    <detail-cluster
      [isHomestay]="isHomestay"
      *ngFor="let cluster of (rooms$ | async); let i = index;"
      [hotelAvailabilityInfo]="hotelAvailabilityInfo"
      [cluster]="cluster"
      [index]="i"
      [priceByValue]="priceByValue"
      [showAmountTotal]="showAmountTotal"
      [hotelStaticInfo]="hotelStaticInfo"
    ></detail-cluster>
  </ng-container>
  <ng-template #noRooms>
    <div class="no-results">
      <span>
        No encontramos disponibilidad para tu búsqueda.
      </span>
      <span>
        Intentá cambiando los filtros.
      </span>
      <div class="image" [ngClass]="brandImage"></div>
    </div>
  </ng-template>
</ng-container>
<ng-template #disneyCluster>
  <disney-cluster
    *ngFor="let cluster of (rooms$ | async); let i = index"
    [hotelAvailabilityInfo]="hotelAvailabilityInfo"
    [cluster]="cluster"
    [index]="i"
    [priceByValue]="priceByValue"
    [showAmountTotal]="showAmountTotal"
    [hotelStatic]="hotelStaticInfo"
    [clusterType]="'prepaid'"
    [isExperts]="isExperts"
  ></disney-cluster>
</ng-template>
<ng-container *ngIf="!isDisney">
  <mb-icon-text *ngIf="areThereMoreRooms$ | async" (click)="showRooms()" class="show-all">
    <span>Ver más habitaciones</span>
    <mb-icon icon="arrow-down"></mb-icon>
  </mb-icon-text>
</ng-container>
